import { gql } from '@apollo/client';

export const GET_USER = gql(/* GraphQL */ `
    query GetUser($id: String!) {
        getUserById(id: $id) {
            id
            username
            firstName
            lastName
            designation
            isActive
            email
            faxNo
            speedDial
            mobileNo {
                number
                countryCode
                dialingCode
            }
            telNo {
                number
                countryCode
                dialingCode
            }
            userRole {
                id
                role
            }
            managerDivision {
                id
                name
                stores {
                    id
                    isClosed
                    isPriceSurveyModuleEnabled
                    advertisingZone {
                        id
                        name
                        isPriceSurveyModuleEnabled
                    }
                }
            }
            managerStore {
                id
                name
                storeNo
                isClosed
                isPriceChangeModuleEnabled
                isPriceSurveyModuleEnabled
                advertisingZone {
                    id
                    name
                    isPriceSurveyModuleEnabled
                }
            }
            sapUser {
                id
                sapId
                userId
            }
        }
    }
`);

export const GET_DROPDOWN_USERS = gql(/* GraphQL */ `
    query GetDropdownUsers(
        $nameSearch: String
        $designationFilter: String
        $roleFilter: String
        $advertisingZoneId: String
        $storeId: String
        $limit: Int
        $includeInactive: Boolean
    ) {
        getUsers(
            nameSearch: $nameSearch
            designationFilter: $designationFilter
            roleFilter: $roleFilter
            advertisingZoneId: $advertisingZoneId
            storeId: $storeId
            limit: $limit
            includeInactive: $includeInactive
        ) {
            id
            firstName
            lastName
            designation
            managerStore {
                id
                name
            }
        }
    }
`);

export const GET_USERS = gql(/* GraphQL */ `
    query GetUsers($designationFilter: String) {
        getUsers(designationFilter: $designationFilter) {
            id
            username
            firstName
            lastName
            designation
            email
            isActive
            mobileNo {
                number
                countryCode
                dialingCode
            }
            telNo {
                number
                countryCode
                dialingCode
            }
            speedDial
            faxNo
            userRole {
                id
                role
            }
            managerDivision {
                id
                name
            }
            managerStore {
                id
                name
            }
            sapUser {
                id
                sapId
                userId
            }
        }
    }
`);

export const GET_USERS_PAGINATED = gql(/* GraphQL */ `
    query GetUsersPaginated(
        $page: Int!
        $pageSize: Int!
        $search: String
        $isActive: Boolean
    ) {
        getUsersPaginated(
            page: $page
            pageSize: $pageSize
            search: $search
            isActive: $isActive
        ) {
            users {
                id
                username
                firstName
                lastName
                designation
                email
                isActive
                mobileNo {
                    number
                    countryCode
                    dialingCode
                }
                telNo {
                    number
                    countryCode
                    dialingCode
                }
                speedDial
                faxNo
                userRole {
                    id
                    role
                }
                managerDivision {
                    id
                    name
                }
                managerStore {
                    id
                    name
                }
                sapUser {
                    id
                    sapId
                    userId
                }
            }
            totalCount
            page
            pageSize
        }
    }
`);

export const GET_ROLES = gql(/* GraphQL */ `
    query GetRoles {
        getRoles {
            id
            role
            permissions
        }
    }
`);

export const GET_SAP_USERS = gql(/* GraphQL */ `
    query GetSapUsers {
        getSapUsers {
            id
            sapId
            userId
        }
    }
`);
